module.exports = __webpack_public_path__ + "static/media/EndocardialSegmentation_1-1267w.68be4a2d.jpg";